/* ============================================================
   MIONA Waitlist · Frontend-Logik
   Verbindet die Anmeldeformulare mit dem Cloudflare Worker.
   Texte/Strings kommen aus der JSON-Config (Locale + Section Settings),
   nichts ist hier hardcodiert.
   ============================================================ */
(function () {
  "use strict";

  var section = document.querySelector("[data-miona-wl]");
  if (!section) return;

  // ---- Config (i18n + Settings) aus dem JSON-Script lesen ----
  var cfg = {};
  try {
    var cfgEl = section.querySelector("[data-miona-wl-config]");
    if (cfgEl) cfg = JSON.parse(cfgEl.textContent);
  } catch (e) {
    cfg = {};
  }
  var t = cfg.i18n || {};

  var WORKER_URL = (cfg.workerUrl || "").replace(/\/+$/, "");
  var PAGE_HANDLE = cfg.pageHandle || "waitlist";
  var SHOP_URL = window.location.origin;

  // ---- Elemente ----
  var forms = section.querySelectorAll("[data-waitlist-form]");
  var errorEls = section.querySelectorAll("[data-error]");
  var counterEls = section.querySelectorAll("[data-counter]");
  var preState = section.querySelector('[data-state="pre"]');
  var postState = section.querySelector('[data-state="post"]');
  var pendingState = section.querySelector('[data-state="pending"]');
  var toastEl = section.querySelector("[data-toast]");
  var ladder = section.querySelector("[data-ladder]");

  // Wen die "Erneut senden"/"Problem melden"-Aktionen betreffen (nach Anmeldung
  // bzw. wenn man ueber ?me=CODE noch unbestaetigt zurueckkommt).
  var pendingId = { email: null, code: null };
  var resendTimer = null;

  // ---- Referral-Code aus URL oder localStorage ----
  var params = new URLSearchParams(window.location.search);
  var refFromUrl = (params.get("ref") || "").trim().toUpperCase();
  if (refFromUrl) {
    try {
      localStorage.setItem("miona_ref", refFromUrl);
    } catch (e) {}
  }
  var incomingRef = refFromUrl || safeGet("miona_ref");
  if (incomingRef) {
    section.querySelectorAll("[data-ref-field]").forEach(function (el) {
      el.value = incomingRef;
    });
  }

  // ---- Dashboard nur bei echter Identifikation zeigen:
  //      (1) persönlicher Stand-Link aus der Mail (?me=CODE),
  //      (2) eingeloggt (verifizierte E-Mail).
  //      NICHT allein aus localStorage (sonst sähe es jeder mit altem Code). ----
  var meCode = (params.get("me") || "").trim().toUpperCase();
  if (meCode && WORKER_URL) {
    loadDashboard(meCode, true);
  } else if (cfg.loggedInEmail && WORKER_URL) {
    loadDashboardByEmail(cfg.loggedInEmail, false);
  }

  // Nach der Double-Opt-in-Bestaetigung (?confirmed=1) eine Erfolgsmeldung zeigen.
  if (params.get("confirmed") === "1" && t.confirmed_toast) {
    showToast(t.confirmed_toast);
  }

  // ---- Counter ----
  // Startwert 473 (counter_fallback) und zaehlt ab da hoch: der Worker liefert
  // COUNTER_OFFSET (473) + echte Anmeldungen. Die Fallback-Zahl steht sofort da,
  // dann animiert der Counter auf den Live-Wert (473 + echte Anmeldungen).
  if (WORKER_URL) loadCounter();

  // ============================================================
  //  EVENTS
  // ============================================================

  forms.forEach(function (form) {
    form.addEventListener("submit", function (e) {
      e.preventDefault();
      submitSignup(form);
    });
  });

  // Kopieren-Buttons (Hero + Dashboard)
  section.querySelectorAll("[data-copy-btn]").forEach(function (btn) {
    btn.addEventListener("click", function () {
      var input = section.querySelector("[data-referral-link]");
      if (!input || !input.value) return;
      copyText(input.value).then(function () {
        showToast(t.copied || "Link kopiert");
      });
    });
  });

  // Teilen-Buttons
  bindShare("[data-share-whatsapp]", function (link) {
    var msg = (t.share_text || "") + " " + link;
    window.open("https://wa.me/?text=" + encodeURIComponent(msg), "_blank");
  });
  bindShare("[data-share-email]", function (link) {
    var subject = encodeURIComponent(t.share_subject || "");
    var body = encodeURIComponent((t.share_text || "") + "\n\n" + link);
    window.location.href = "mailto:?subject=" + subject + "&body=" + body;
  });
  bindShare("[data-share-native]", function (link) {
    if (navigator.share) {
      navigator
        .share({ title: t.share_subject || "", text: t.share_text || "", url: link })
        .catch(function () {});
    } else {
      copyText(link).then(function () {
        showToast(t.copied || "Link kopiert");
      });
    }
  });

  // Hinweis: "Schon dabei?" ist jetzt selbst ein <shopify-account> (echter
  // Klick-Trigger), daher kein JS-Fernsteuern des Männchens mehr nötig.

  // ============================================================
  //  FUNKTIONEN
  // ============================================================

  function submitSignup(form) {
    var emailInput = form.querySelector('input[type="email"]');
    var email = emailInput ? emailInput.value.trim() : "";
    var refField = form.querySelector("[data-ref-field]");
    var ref = refField && refField.value ? refField.value : incomingRef || null;
    var btn = form.querySelector('button[type="submit"], button:not([type])');
    var btnLabel = btn ? btn.textContent : "";

    clearErrors();

    // Pflicht: Einverstaendnis fuer E-Mails (Haken muss gesetzt sein)
    var consentBox = form.querySelector("[data-consent]");
    if (consentBox && !consentBox.checked) {
      setError(t.error_consent || "Bitte bestätige, dass du E-Mails von MIONA erhalten möchtest.");
      if (consentBox.focus) consentBox.focus();
      return;
    }

    if (!WORKER_URL) {
      setError(t.error_generic || "Etwas ist schiefgelaufen.");
      return;
    }

    if (btn) {
      btn.disabled = true;
      btn.dataset.label = btnLabel;
      btn.textContent = "...";
    }

    fetch(WORKER_URL + "/signup", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ email: email, ref: ref, consent: true }),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (r) {
        var data = r.data || {};
        if (r.ok && data.success) {
          safeRemove("miona_ref"); // Ref aufgebraucht
          setUrlMe(data.referral_code); // Stand bleibt bei Reload erhalten
          pendingId = { email: email, code: data.referral_code };
          if (data.pending) {
            // Double-Opt-in: erst Mail bestaetigen, dann zaehlt es.
            showPending(true);
            if (t.pending_toast) showToast(t.pending_toast);
          } else {
            setReferralLinks(data.referral_code);
            renderDashboard(data);
            revealDashboard(true);
            if (t.signup_toast) showToast(t.signup_toast);
          }
        } else if (data.error === "already_registered" && data.referral_code) {
          setUrlMe(data.referral_code);
          pendingId = { email: email, code: data.referral_code };
          if (data.active === false) {
            showPending(true); // angemeldet, aber noch nicht bestaetigt
          } else {
            loadDashboard(data.referral_code, true);
          }
        } else if (data.error === "invalid_email") {
          setError(t.error_invalid_email || "Bitte gib eine gueltige E-Mail an.");
        } else {
          setError(t.error_generic || "Etwas ist schiefgelaufen.");
        }
      })
      .catch(function () {
        setError(t.error_connection || "Verbindungsfehler. Bitte versuche es erneut.");
      })
      .then(function () {
        if (btn) {
          btn.disabled = false;
          btn.textContent = btn.dataset.label || btnLabel;
        }
      });
  }

  function loadStatus(query, scroll) {
    if (!WORKER_URL) return;
    fetch(WORKER_URL + "/status?" + query)
      .then(function (res) {
        if (!res.ok) throw new Error("status");
        return res.json();
      })
      .then(function (data) {
        if (data.referral_code) remember("miona_my_code", data.referral_code);
        if (data.active === false) {
          // Noch nicht bestaetigt -> Pending-Hinweis statt Dashboard.
          if (data.referral_code) pendingId.code = data.referral_code;
          showPending(!!scroll);
          return;
        }
        setReferralLinks(data.referral_code);
        renderDashboard(data);
        revealDashboard(!!scroll);
      })
      .catch(function () {
        /* Still: einfach das Formular stehen lassen */
      });
  }

  function loadDashboard(code, scroll) {
    loadStatus("code=" + encodeURIComponent(code), scroll);
  }

  function loadDashboardByEmail(email, scroll) {
    loadStatus("email=" + encodeURIComponent(email), scroll);
  }

  // URL auf den persönlichen Stand-Link setzen (?me=CODE), damit ein Reload
  // das Dashboard behält - ohne sich nur auf localStorage zu verlassen.
  function setUrlMe(code) {
    try {
      if (code && window.history && history.replaceState) {
        history.replaceState(null, "", "?me=" + encodeURIComponent(code));
      }
    } catch (e) {}
  }

  function renderDashboard(data) {
    var level = data.level || 1;
    var invites = data.invite_count || 0;
    var levels = data.levels || ladderLevels(); // Fallback aus dem DOM

    setText("[data-level]", level);
    setText("[data-invite-count]", invites);

    // Eigene Founder-Nummer in die Plakette (Nº) oben rechts schreiben und gegen
    // den globalen Live-Counter locken (data-locked -> animateCounter lässt sie in Ruhe).
    var sealNum = section.querySelector(".miona-wl__seal-num");
    if (sealNum && data.founder_number) {
      sealNum.setAttribute("data-locked", "1");
      sealNum.textContent = formatNum(data.founder_number);
    }

    // Progress zum naechsten Level
    var current = levels[level - 1] || { required: 0 };
    var next = levels[level] || null;
    var fill = section.querySelector("[data-progress-bar]");
    var labRemaining = section.querySelector("[data-next-remaining]");
    var labCount = section.querySelector("[data-next-count]");

    if (next) {
      var span = next.required - current.required;
      var done = invites - current.required;
      var pct = span > 0 ? Math.max(0, Math.min(100, (done / span) * 100)) : 100;
      if (fill) fill.style.width = pct + "%";
      var remaining = Math.max(0, next.required - invites);
      if (labRemaining)
        labRemaining.textContent = tpl(t.next_level_remaining, {
          count: remaining,
          level: next.level,
        });
      if (labCount) labCount.textContent = invites + " / " + next.required;
    } else {
      if (fill) fill.style.width = "100%";
      if (labRemaining) labRemaining.textContent = t.max_level || "";
      if (labCount) labCount.textContent = "";
    }

    // Ladder: freigeschaltete Stufen markieren + Status-Text setzen
    if (ladder) {
      ladder.querySelectorAll("[data-tier]").forEach(function (tier) {
        var req = parseInt(tier.getAttribute("data-required"), 10) || 0;
        var statEl = tier.querySelector("[data-tier-stat]");
        if (invites >= req) {
          tier.classList.add("is-unlocked");
          if (statEl) statEl.textContent = t.unlocked_word || "Freigeschaltet";
        } else {
          tier.classList.remove("is-unlocked");
          if (statEl)
            statEl.textContent = tpl(t.locked_remaining, { count: req - invites });
        }
      });
    }
  }

  function revealDashboard(scroll) {
    // Mitglied-Modus: Gast-Inhalte (Hero-Formular, Nav-CTA, Final-CTA) aus,
    // Mitglied-Begrüßung an.
    section.classList.remove("is-pending");
    section.classList.add("is-member");
    if (pendingState) pendingState.hidden = true;
    if (preState) preState.hidden = true;
    if (postState) postState.hidden = false;
    if (scroll && postState && postState.scrollIntoView) {
      postState.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  // Double-Opt-in: angemeldet, aber noch nicht bestaetigt. Statt Dashboard den
  // Hinweis "Bitte aktiviere deine Membership" zeigen (Gast-Inhalte aus).
  function showPending(scroll) {
    section.classList.remove("is-member");
    section.classList.add("is-pending");
    if (preState) preState.hidden = true;
    if (postState) postState.hidden = true;
    if (pendingState) pendingState.hidden = false;
    var target = pendingState || section;
    if (scroll && target.scrollIntoView) {
      target.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  }

  // ---- "E-Mail erneut senden" mit Countdown-Sperre ----
  var resendBtn = section.querySelector("[data-resend]");

  function startResendCooldown(sec) {
    if (!resendBtn) return;
    var remaining = sec;
    var base = t.resend_label || resendBtn.textContent;
    resendBtn.disabled = true;
    if (resendTimer) clearInterval(resendTimer);
    function tick() {
      if (remaining <= 0) {
        clearInterval(resendTimer);
        resendTimer = null;
        resendBtn.disabled = false;
        resendBtn.textContent = base;
        return;
      }
      resendBtn.textContent = tpl(t.resend_wait || "Erneut senden in {count}s", {
        count: remaining,
      });
      remaining--;
    }
    tick();
    resendTimer = setInterval(tick, 1000);
  }

  if (resendBtn) {
    resendBtn.addEventListener("click", function () {
      if (resendBtn.disabled || !WORKER_URL) return;
      if (!pendingId.email && !pendingId.code) return;
      startResendCooldown(60); // sofort wieder sperren
      fetch(WORKER_URL + "/resend", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ email: pendingId.email, code: pendingId.code }),
      })
        .then(function (res) {
          return res.json().then(function (d) {
            return { ok: res.ok, data: d };
          });
        })
        .then(function (r) {
          if (r.data && r.data.already_active) {
            showToast(t.resend_active || "Du bist bereits aktiviert.");
          } else if (r.ok && r.data && r.data.sent) {
            showToast(t.resend_done || "Erledigt, wir haben dir die E-Mail nochmal geschickt.");
          } else if (r.data && r.data.error !== "cooldown") {
            showToast(t.error_generic || "Etwas ist schiefgelaufen.");
          }
        })
        .catch(function () {
          showToast(t.error_connection || "Verbindungsfehler. Bitte versuche es erneut.");
        });
    });
  }

  // ---- "Problem melden" Popup ----
  var reportModal = section.querySelector("[data-report-modal]");
  var reportMsg = section.querySelector("[data-report-msg]");
  var reportEmail = section.querySelector("[data-report-email]");

  function openReport() {
    if (!reportModal) return;
    // An den Section-Root hängen: Panels mit backdrop-filter/blur wären sonst
    // der Bezug für position:fixed, das Modal säße nicht mittig über dem Screen.
    if (reportModal.parentNode !== section) section.appendChild(reportModal);
    if (reportEmail && pendingId.email) reportEmail.value = pendingId.email;
    reportModal.hidden = false;
    if (reportMsg && reportMsg.focus) reportMsg.focus();
  }
  function closeReport() {
    if (reportModal) reportModal.hidden = true;
  }

  section.querySelectorAll("[data-report-open]").forEach(function (b) {
    b.addEventListener("click", openReport);
  });
  section.querySelectorAll("[data-report-cancel]").forEach(function (b) {
    b.addEventListener("click", closeReport);
  });

  var reportSend = section.querySelector("[data-report-send]");
  if (reportSend) {
    reportSend.addEventListener("click", function () {
      if (!WORKER_URL || !reportMsg) return;
      var msg = (reportMsg.value || "").trim();
      if (!msg) {
        if (reportMsg.focus) reportMsg.focus();
        return;
      }
      var mail = reportEmail && reportEmail.value ? reportEmail.value.trim() : pendingId.email;
      reportSend.disabled = true;
      fetch(WORKER_URL + "/report", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          message: msg,
          email: mail,
          code: pendingId.code,
          page: window.location.pathname,
        }),
      })
        .then(function (res) {
          return res.json();
        })
        .then(function () {
          reportMsg.value = "";
          closeReport();
          showToast(t.report_done || "Danke, deine Nachricht ist bei uns angekommen.");
        })
        .catch(function () {
          showToast(t.error_connection || "Verbindungsfehler. Bitte versuche es erneut.");
        })
        .then(function () {
          reportSend.disabled = false;
        });
    });
  }

  function setReferralLinks(code) {
    var link = SHOP_URL + "/pages/" + PAGE_HANDLE + "?ref=" + code;
    section.querySelectorAll("[data-referral-link]").forEach(function (el) {
      el.value = link;
    });
    section.setAttribute("data-my-link", link);
  }

  function loadCounter() {
    fetch(WORKER_URL + "/count")
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        if (typeof data.count === "number") {
          // Alle Counter (Social-Proof-Zeile + Founding-Siegel) auf denselben Wert hochzählen
          counterEls.forEach(function (el) {
            animateCounter(el, data.count);
          });
        }
      })
      .catch(function () {
        /* Counter bleibt einfach auf dem statischen Fallback stehen */
      });
  }

  function animateCounter(el, target) {
    // Gelockte Elemente (z. B. Siegel mit eigener Founder-Nummer) nicht anfassen.
    if (el.getAttribute("data-locked")) return;
    var reduce =
      window.matchMedia &&
      window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (reduce) {
      el.textContent = formatNum(target);
      return;
    }
    var current = 0;
    var duration = 1400;
    var step = target / (duration / 16);
    var timer = setInterval(function () {
      if (el.getAttribute("data-locked")) {
        clearInterval(timer);
        return;
      }
      current += step;
      if (current >= target) {
        el.textContent = formatNum(target);
        clearInterval(timer);
      } else {
        el.textContent = formatNum(Math.floor(current));
      }
    }, 16);
  }

  // ---- Ladder-Level aus dem DOM (Fallback, falls /status keine liefert) ----
  function ladderLevels() {
    // Level 1 = 0 Einladungen; die Ladder-Blöcke sind die freischaltbaren
    // Stufen darüber (müssen mit LEVEL_THRESHOLDS im Worker übereinstimmen).
    var out = [{ level: 1, required: 0 }];
    if (ladder) {
      ladder.querySelectorAll("[data-tier]").forEach(function (tier) {
        out.push({
          level: out.length + 1,
          required: parseInt(tier.getAttribute("data-required"), 10) || 0,
        });
      });
    }
    return out;
  }

  // ============================================================
  //  HELPERS
  // ============================================================

  function bindShare(selector, handler) {
    section.querySelectorAll(selector).forEach(function (btn) {
      btn.addEventListener("click", function () {
        var link = section.getAttribute("data-my-link");
        if (!link) {
          var input = section.querySelector("[data-referral-link]");
          link = input ? input.value : "";
        }
        if (link) handler(link);
      });
    });
  }

  function setText(selector, value) {
    section.querySelectorAll(selector).forEach(function (el) {
      el.textContent = value;
    });
  }

  function setError(msg) {
    errorEls.forEach(function (el) {
      el.textContent = msg;
    });
  }
  function clearErrors() {
    errorEls.forEach(function (el) {
      el.textContent = "";
    });
  }

  function showToast(msg) {
    if (!toastEl) return;
    toastEl.textContent = msg;
    toastEl.classList.add("is-show");
    clearTimeout(toastEl._timer);
    toastEl._timer = setTimeout(function () {
      toastEl.classList.remove("is-show");
    }, 2200);
  }

  function copyText(text) {
    if (navigator.clipboard && navigator.clipboard.writeText) {
      return navigator.clipboard.writeText(text).catch(function () {
        return legacyCopy(text);
      });
    }
    return legacyCopy(text);
  }
  function legacyCopy(text) {
    return new Promise(function (resolve) {
      var ta = document.createElement("textarea");
      ta.value = text;
      ta.style.position = "fixed";
      ta.style.opacity = "0";
      document.body.appendChild(ta);
      ta.select();
      try {
        document.execCommand("copy");
      } catch (e) {}
      document.body.removeChild(ta);
      resolve();
    });
  }

  function tpl(str, vars) {
    if (!str) return "";
    return str.replace(/\{(\w+)\}/g, function (_, k) {
      return vars[k] != null ? vars[k] : "";
    });
  }

  function formatNum(n) {
    try {
      return n.toLocaleString("de-DE");
    } catch (e) {
      return String(n);
    }
  }

  function safeGet(k) {
    try {
      return localStorage.getItem(k);
    } catch (e) {
      return null;
    }
  }
  function remember(k, v) {
    try {
      localStorage.setItem(k, v);
    } catch (e) {}
  }
  function safeRemove(k) {
    try {
      localStorage.removeItem(k);
    } catch (e) {}
  }
})();
